import { ApiRequestService } from "services/ApiRequestService";

export const BulkImportMappingService = {
    searchMappings(microserviceKey, searchRequest) {
        return ApiRequestService.post(microserviceKey, "BulkImportMappings/Search", searchRequest);
    },
    getMappingsByType(microserviceKey, bulkImportTypeKey) {
        return ApiRequestService.get(microserviceKey, `BulkImportMappings/Type/${bulkImportTypeKey}`);
    },
    createMapping(microserviceKey, request) {
        return ApiRequestService.post(microserviceKey, "BulkImportMappings", request);
    },
    updateMapping(microserviceKey, bulkImportMappingId, request) {
        return ApiRequestService.put(microserviceKey, `BulkImportMappings/${bulkImportMappingId}`, request);
    },
    deleteMapping(microserviceKey, bulkImportMappingId) {
        return ApiRequestService.delete(microserviceKey, `BulkImportMappings/${bulkImportMappingId}`);
    }
};
